// store.ts
import { createContext, useContext } from "react";
import CartStore from "./cartStore";
import CommonStore from "./commonStore";
import ModalStore from "./modalStore";
import ProductsStore from "./productsStore";
import SearchStore from "./searchStore";
import UserStore from "./userStore";
import BookingStore from "./bookingStore"; // Assuming you have this
import WishlistStore from "./wishlistStore"; // Assuming you have this
import CouponStore from "./couponStore";
import CategoryStore from "./categoryStore";
import ParentCategoryStore from "./parentCategoryStore";
import NewArrivalProductsStore from "./newarrivalProductsStore";

export class RootStore {
    productsStore: ProductsStore;
    userStore: UserStore;
    searchStore: SearchStore;
    cartStore: CartStore;
    commonStore: CommonStore;
    modalStore: ModalStore;
    bookingStore: BookingStore;
    wishlistStore: WishlistStore;
    couponStore:CouponStore;
    categoryStore:CategoryStore;
    parentCategoryStore:ParentCategoryStore;
    newarrivalProductsStore:NewArrivalProductsStore;

    constructor() {
        // Instantiate stores and pass 'this' to children
        this.commonStore = new CommonStore(this);
        this.modalStore = new ModalStore(this);
        this.productsStore = new ProductsStore(this);
        this.searchStore = new SearchStore(this);
        this.cartStore = new CartStore(this);
        this.bookingStore = new BookingStore(this);
        this.wishlistStore = new WishlistStore(this);
        this.couponStore = new CouponStore(this);
        
        // userStore usually comes last as it often depends on others
        this.userStore = new UserStore(this);
        this.categoryStore = new CategoryStore(this);
        this.parentCategoryStore = new ParentCategoryStore(this);
        this.newarrivalProductsStore = new NewArrivalProductsStore(this);
    }
}

// Create the singleton instance
export let store = new RootStore();

// React Context for using the store in components
export let StoreContext = createContext(store);

export function useStore() {
    return useContext(StoreContext);
}